import TagsDB, { TagEntity } from 'src/firebase/db/Tags';
import MessagesDB, { MessageEntity } from 'src/firebase/db/Messages';

/**
 * タグの取得
 */
export const getTags = () => {
  return TagsDB.getAllTags();
};

/**
 * タグの登録
 */
export const createTag = (query: Partial<TagEntity>) => {
  return TagsDB.create(query);
};

export const updateTag = (query: Partial<TagEntity>) => {
  return TagsDB.update(query);
};

export const createPushMessage = (query: Partial<MessageEntity>) => {
  return MessagesDB.create(query);
};

export const getPushMessages = () => {
  return MessagesDB.getPushNotifications();
};
